export const BASE_PATH = '/blog';

/**
 * Blog routes paths
 * Note these depend on us leveraging Next.js basePath. See https://nextjs.org/docs/api-reference/next.config.js/basepath
 */
const paths = {
  basePath: BASE_PATH,
  blogArticle: (slug: string) => `${BASE_PATH}/${slug}/`,
  categoryPage: ({
    categoryAssemblySlug,
    page,
  }: {
    categoryAssemblySlug: string;
    page?: number;
  }) =>
    page
      ? `${BASE_PATH}/all-articles/${categoryAssemblySlug}/${page}`
      : `${BASE_PATH}/all-articles/${categoryAssemblySlug}`,
  allArticlesPage: (page: string) => `${BASE_PATH}/all-articles/${page}`,
  /**
   * We need this function so Next.js doesn't append an extra `baseUrl` when we render the page. This is needed
   * because we have to use Next.js router with ZDS dropdown which doesn't support our Link component.
   *
   * Look the [[...segment.tsx]] file for reference
   */
  allArticlesPageWithNextRouter: (page: string) => `/all-articles/${page}`,
  categoryHome: (slug: string) => `${BASE_PATH}/categories/${slug}`,
};

export default paths;
